import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useParams } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { TextField, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import CommentBodyContainer from "views/Grievance/Comment/CommentBodyContainer";
import eightAxios from "configs/axiosConfig";
import { COMMENT_URL } from "configs/constants";
import { useNotifyContext } from "@Components/Notify";

const GrievanceComment = (props) => {
  const { value, passedValue, renderOnly } = props;
  const [comments, setComments] = useState([]);
  const [commentBody, setCommentBody] = useState("");
  const params = useParams();
  const setNotify = useNotifyContext();
  const { t } = useTranslation();


  useEffect(() => {
    if (value) setComments(value);
  }, [value]);

  const handleSubmit = (commentType, event) => {
    event.preventDefault();
    if (commentBody.trim().length === 0) {
      setNotify({
        isOpen: true,
        message: "Comment body cannot be empty",
        type: "error",
      });
      return;
    }

    const payload = {
      text_message: commentBody,
      grievance: params.id,
      is_internal: commentType === "internal",
    };
    eightAxios
      .post(COMMENT_URL, payload)
      .then((response) => {
        setCommentBody("");
        setComments([...comments, response.data]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return renderOnly ? (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Paper
          style={{
            backgroundColor: "rgba(211,211,211,0.49)",
            borderRadius: 0,
            padding: "5px",
          }}
        >
          {comments.map((comment, index) => {
            return (
              <CommentBodyContainer
                key={index}
                comment={comment}
                comments={comments}
                setComments={setComments}
                userLanguage={passedValue}
                renderOnly={renderOnly}
              />
            );
          })}
        </Paper>
      </Grid>
    </Grid>
  ) : (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Paper
          style={{
            backgroundColor: "rgba(211,211,211,0.49)",
            borderRadius: 0,
            padding: "5px",
          }}
        >
          {comments.map((comment, index) => {
            return (
              <CommentBodyContainer
                key={index}
                comment={comment}
                comments={comments}
                setComments={setComments}
                userLanguage={passedValue}
              />
            );
          })}
        </Paper>
      </Grid>

      <Grid container item spacing={1}>
        <Grid item xs={12}>
          <TextField
            multiline
            rows={4}
            value={commentBody}
            onChange={(event) => setCommentBody(event.target.value)}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            style={{
              borderRadius: 0,
              textTransform: "capitalize",
              width: "100px",
            }}
            onClick={(event) => handleSubmit("internal", event)}
          >
            {t("Internal")}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            style={{
              borderRadius: 0,
              textTransform: "capitalize",
              width: "150px",
            }}
            onClick={(event) => handleSubmit("send", event)}
          >
            {t("Send to mobile")}

          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

GrievanceComment.propTypes = {
  value: PropTypes.array,
  passedValue: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  meta: PropTypes.object,
  renderOnly: PropTypes.bool,
};

export default GrievanceComment;
